import { OAuthModuleConfig } from 'angular-oauth2-oidc';

export function getApiConfig<T extends Record<keyof T, string>>(
  apiConfig: T,
): T & Record<'authModuleConfig', OAuthModuleConfig> {
  return {
    ...apiConfig,
    authModuleConfig: {
      resourceServer: {
        allowedUrls: Object.values(apiConfig),
        // we use our own oauth interceptor to send the token
        sendAccessToken: false,
      },
    },
  };
}
